
import styles from "../../AccountingPage.module.scss";
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getStudentsData, postStudentsData, getAcademicYearsData, getBranchesData, getEducationTypesData, getDepartmentsData, getSpecialitiesData, getCoursesData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import StudentDetailContent from "./components/StudentDetailContent"
import StudentsRelease from "./StudentsRelease"
import StudentsCourseForCourse from "./StudentsCourseForCourse"

const StudentsContent = ({ render, setRender, id }) => {
    const componentRef = useRef();

    const [academicyears, setAcademicYears] = useState([]);
    const getAcademicYears = async (id) => {
        try {
            let response = await getAcademicYearsData(id, academicyears);
            setAcademicYears(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };
    const [branches, setBranches] = useState([]);
    const getBranches = async (id) => {
        try {
            let response = await getBranchesData(id, branches);
            setBranches(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [educationtypes, setEducationTypes] = useState([]);
    const getEducationTypes = async (id) => {
        try {
            let response = await getEducationTypesData(id, educationtypes);
            setEducationTypes(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [departments, setDepartments] = useState([]);
    const getDepartments = async (id) => {
        try {
            let response = await getDepartmentsData(id, departments);
            setDepartments(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [specialities, setSpecialities] = useState([]);
    const getSpecialities = async (id) => {
        try {
            let response = await getSpecialitiesData(id, departments);
            setSpecialities(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [courses, setCourses] = useState([]);
    const getCourses = async (id) => {
        try {
            let response = await getCoursesData(id, courses);
            setCourses(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };


    const [academicYearID, setAcademicYearID] = useState("");
    const [branchID, setBranchID] = useState("");
    const [departmentID, setDepartmentID] = useState("");
    const [educationTypeID, setEducationTypeID] = useState("");
    const [courseID, setCourseID] = useState("");
    const [specialitieID, setSpecialitieID] = useState("");

    const handleSelectAcademicYear = (id) => {
        setAcademicYearID(id);
    };
    const handleSelectBranch = (id) => {
        setBranchID(id);
        getDepartments(id)
        setDepartmentID("")
    };
    const handleSelectDepartment = (id) => {
        setDepartmentID(id);
        getSpecialities(id)
        setSpecialitieID("")
    };
    const handleSelectEducationType = (id) => {
        setEducationTypeID(id);
    };
    const handleSelectCourse = (id) => {
        setCourseID(id);
    };
    const handleSelectSpecialitie = (id) => {
        setSpecialitieID(id);
    };
    const [inn, setInn] = useState("");
    const [surname, setSurname] = useState("");
    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");
    const [citizenship, setCitizenship] = useState("");
    const [order, setOrder] = useState("");

    useEffect(() => {

        getAcademicYears(id);
        getBranches(id);
        getCourses(id);
        getEducationTypes(id);
        setRender(false);

        // getData(id);


    }, [render]);
    const [openModal, setOpenModal] = useState(false);


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [data, setData] = useState([]);
    const getData = async (id) => {
        try {
            let response = await getStudentsData(id, data);
            setData(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };





    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!inn) {
            setNotify({
                isOpen: true,
                message: "Введите ИНН!",
                type: "error",
            });

        }
        else if (!academicYearID) {
            setNotify({
                isOpen: true,
                message: "Выберите учебный год!",
                type: "error",
            });

        }
        else if (!educationTypeID) {
            setNotify({
                isOpen: true,
                message: "Выберите вид обучения!",
                type: "error",
            });

        }
        else if (!specialitieID) {
            setNotify({
                isOpen: true,
                message: "Выберите специальность!",
                type: "error",
            });

        }
        else if (!courseID) {
            setNotify({
                isOpen: true,
                message: "Выберите курс!",
                type: "error",
            });

        }


        else if (!surname) {
            setNotify({
                isOpen: true,
                message: "Введите Фамилию!",
                type: "error",
            });

        }
        else if (!first_name) {
            setNotify({
                isOpen: true,
                message: "Введите Имя!",
                type: "error",
            });

        }

        else if (!citizenship) {
            setNotify({
                isOpen: true,
                message: "Введите гражданство!",
                type: "error",
            });

        }
        else if (!order) {
            setNotify({
                isOpen: true,
                message: "Введите приказ о зачислении!",
                type: "error",
            });

        }




        else {
            const formData = new FormData();
            formData.append('inn', inn);
            formData.append('academic_year', academicYearID);
            formData.append('order', order);
            formData.append('citizenship', citizenship);
            formData.append('speciality', specialitieID);
            formData.append('educationtype', educationTypeID);
            formData.append('course', courseID);
            formData.append('last_name', last_name);
            formData.append('surname', surname);
            formData.append('first_name', first_name);
            let data = await postStudentsData(id, formData);

            getData();



            setInn("");
            setSurname("");
            setFirstName("");
            setLastName("");
            setCitizenship("");
            setOrder("");
            setAcademicYearID("");
            setBranchID("");
            setDepartmentID("");
            setEducationTypeID("");
            setCourseID("");
            setSpecialitieID("");
            setOpenModal(false)

            setNotify({
                isOpen: true,
                message: "Студент успешно создан!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }

    };

    useEffect(() => {

        getData(id);

        setRender(false);



    }, [render]);



    const [searchName, setSearchName] = useState('');
    const [searchStatus, setSearchStatus] = useState('');
    const [searchCourse, setSearchCourse] = useState('');
    const [searchSpeciality, setSearchSpeciality] = useState('');
    const [searchCitizenship, setSearchCitizenship] = useState('');
    const [searchSurname, setSearcSurname] = useState('');
    const [searchEduType, setSearcEduType] = useState('');
    const [searchAcademYear, setSearchAcademYear] = useState('');

    const [searchInn, setSearchInn] = useState('');
    const filteredData = Array.isArray(data)
        ? data.filter((item) => {
            const matchStatus = searchStatus ? item.status?.toLowerCase().includes(searchStatus.toLowerCase()) : true;
            const matchCourse = searchCourse ? item.course_name?.toLowerCase().includes(searchCourse.toLowerCase()) : true;
            const matchSpeciality = searchSpeciality ? item.speciality_name?.toLowerCase().includes(searchSpeciality.toLowerCase()) : true;
            const matchCitizenship = searchCitizenship ? item.citizenship?.toLowerCase().includes(searchCitizenship.toLowerCase()) : true;
            const matchName = searchName ? item.first_name?.toLowerCase().includes(searchName.toLowerCase()) : true;
            const matchSurname = searchSurname ? item.surname?.toLowerCase().includes(searchSurname.toLowerCase()) : true;
            const matchEduType = searchEduType ? item.educationtype_name?.includes(searchEduType) : true;
            const matchInn = searchInn ? item.inn?.toLowerCase().includes(searchInn.toLowerCase()) : true;
            const matchAcademYear = searchAcademYear ? item.academic_year_name?.toLowerCase().includes(searchAcademYear.toLowerCase()) : true;
            return (
                matchStatus &&
                matchCourse &&
                matchSpeciality &&
                matchCitizenship &&
                matchName &&
                matchSurname &&
                matchInn &&
                matchEduType &&
                matchAcademYear
            );
        })
        : [];


    const clearFilters = () => {
        setSearchStatus('');
        setBranchID("");
        setDepartmentID("");
        setSearchCourse('');
        setSearchSpeciality('');
        setSearchCitizenship('');
        setSearchName('');
        setSearcSurname('');
        setSearchInn('');
        setSearcEduType('');
        setSearchAcademYear('');
        setCurrentPage(1);
    };


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);



    const [openWindowId, setOpenWindowId] = React.useState(null);
    const [openWindowName, setOpenWindowName] = React.useState(null);
    const [openWindowItem, setOpenWindowItem] = React.useState(null);
    const handleOpenWindow = (item) => {
        setOpenWindowId(item.id);
        setOpenWindowName(item.inn);
        setOpenWindowItem(item);
    };
    // функция для закрытия WindowContent (возврата назад)
    const handleCloseWindow = () => {
        setOpenWindowId(null);
        setOpenWindowName('');
        setOpenWindowItem('');
    };
    const [activeForm, setActiveForm] = useState("");
    return (
        <>
            {!openWindowId && (
                <>

                    <>

                        <div className={styles.content_header}>

                            <h2 className={styles.project__h}>Обучающиеся</h2>
                            <button className={styles.btn_print} onClick={handlePrint} >Печать 🖨️ </button>

                            <div className={styles.table__item__div}>
                                {activeForm ? (

                                    <button className={styles.open_btn_sub_two} style={{ background: "black" }} onClick={() => setActiveForm("")}>
                                        Закрыть ❌
                                    </button>


                                ) : ""}

                                <button
                                    onClick={() => setActiveForm("courseforcourse")}
                                    className={styles.open_btn_sub_two}
                                    style={{
                                        background: activeForm === "courseforcourse" ? "#5C5CFF" : "black",
                                        color: activeForm === "courseforcourse" ? "#fff" : "#ccc",
                                    }}
                                >
                                    Перевод с курса на курс
                                </button>

                                <button
                                    onClick={() => setActiveForm("release")}
                                    className={styles.open_btn_sub_two}

                                    style={{
                                        background: activeForm === "release" ? "#008000" : "black",
                                        color: activeForm === "release" ? "#fff" : "#ccc",
                                    }}
                                >
                                    Выпуск
                                </button>




                            </div>
                            <Button className={styles.btn_pin} onClick={() => setOpenModal(true)} >
                                Добавить студента
                            </Button>
                        </div>
                        {activeForm === "" && (
                            <>
                                <div className={styles.div_search}>
                                    <h2 className={styles.project__h}>Фильтр</h2>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="По ИНН"
                                            value={searchInn}
                                            onChange={(e) => setSearchInn(e.target.value)}
                                            style={{ width: "30%" }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="По Фамилии"
                                            value={searchSurname}
                                            onChange={(e) => setSearcSurname(e.target.value)}
                                            style={{ width: "30%" }}
                                        />

                                        <input
                                            type="text"
                                            placeholder="По Имени"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                            style={{ width: "30%" }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Гражданство"
                                            value={searchCitizenship}
                                            onChange={(e) => setSearchCitizenship(e.target.value)}
                                            style={{ width: "30%" }}
                                        />
                                        <select
                                            value={searchAcademYear}
                                            onChange={(e) => setSearchAcademYear(e.target.value)}
                                            style={{ width: "30%" }}
                                        >
                                            <option value="">Все учебные года</option>
                                            {Array.isArray(academicyears) && academicyears.map((item) => (
                                                <option key={item.id} value={item.name}>{item.name}</option>
                                            ))}
                                        </select>

                                        {/* Вид обучения */}
                                        <select
                                            value={searchEduType}
                                            onChange={(e) => setSearcEduType(e.target.value)}
                                            style={{ width: "30%" }}
                                        >
                                            <option value="">Все виды обучения</option>
                                            {Array.isArray(educationtypes) && educationtypes.map((item) => (
                                                <option key={item.id} value={item.name}>{item.name}</option>
                                            ))}
                                        </select>

                                        {/* Специальность */}

                                        {/* Курс */}
                                        <select
                                            value={searchCourse}
                                            onChange={(e) => setSearchCourse(e.target.value)}
                                            style={{ width: "30%" }}
                                        >
                                            <option value="">Все курсы</option>
                                            {Array.isArray(courses) && courses.map((item) => (
                                                <option key={item.id} value={item.name}>{item.name}</option>
                                            ))}
                                        </select>

                                        {/* Статус */}
                                        <select
                                            value={searchStatus}
                                            onChange={(e) => setSearchStatus(e.target.value)}
                                            style={{ width: "30%" }}
                                        >
                                            <option value="">Все статусы</option>
                                            <option value="Зачислен(а)">Зачислен(а)</option>
                                            <option value="Отчислен(а)">Отчислен(а)</option>
                                            <option value="В академическом отпуске">В академическом отпуске</option>
                                            <option value="Переведен(а)">Переведен(а)</option>
                                            <option value="Выпущен(а)">Выпущен(а)</option>
                                        </select>
                                        <Button onClick={clearFilters} className={styles.clear__button} >
                                            Очистить
                                        </Button>

                                    </div>
                                    <div>
                                        <select
                                            value={branchID}
                                            onChange={(e) => handleSelectBranch(e.target.value)}
                                        >
                                            <option value="">Выберите филиал</option>
                                            {Array.isArray(branches) && branches.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>


                                        <select
                                            value={departmentID}
                                            onChange={(e) => handleSelectDepartment(e.target.value)}
                                        >
                                            <option value="">Выберите подразделение</option>
                                            {Array.isArray(departments) && departments.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                        <select
                                            value={searchSpeciality}
                                            onChange={(e) => setSearchSpeciality(e.target.value)}
                                            style={{ width: "30%" }}
                                        >
                                            <option value="">Все специальности</option>
                                            {Array.isArray(specialities) && specialities.map((item) => (
                                                <option key={item.id} value={item.name}>{item.name}</option>
                                            ))}
                                        </select>

                                    </div>

                                </div>

                                <table ref={componentRef} className={styles.table__wrapper}>
                                    <thead className={styles.table__head}>
                                        <tr className={styles.table__row}>
                                            <th className={styles.table__item_student}>№</th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Учебный год</span>
                                            </th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Вид обучения </span>
                                            </th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>ИНН</span>
                                            </th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Фамилия </span>
                                            </th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Имя </span>
                                            </th>

                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Специальность </span>
                                            </th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Курс </span>
                                            </th>
                                            <th className={styles.table__item_student}>
                                                <span className={styles.table__title}>Статус </span>
                                            </th>
                                            <th className={styles.table__item__nav} >
                                                <span className={styles.table__title}>Действия</span>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className={styles.table__body}>
                                        {currentItems.map((item, index) => (

                                            <tr className={styles.table__row} key={item.id}>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title}>
                                                        {index + 1 + (currentPage - 1) * itemsPerPage}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.academic_year_name}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.educationtype_name}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.inn}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.surname}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.first_name}
                                                    </span>
                                                </td>


                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.speciality_name}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                                        {item.course_name}
                                                    </span>
                                                </td>

                                                <td className={styles.table__item_student}>
                                                    <span
                                                        className={styles.table__title}
                                                        style={{
                                                            fontWeight: '700',
                                                            padding: '5px',
                                                            borderRadius: '6px',
                                                            display: "block",
                                                            textAlign: "center",
                                                            background:
                                                                item.status === 'Зачислен(а)' ? '#5C5CFF' :
                                                                    item.status === 'Отчислен(а)' ? '#a00000ff' :
                                                                        item.status === 'В академическом отпуске' ? '#ec9900ff' :
                                                                            item.status === 'Переведен(а)' ? '#333333' :
                                                                                item.status === 'Выпущен(а)' ? '#008000' :
                                                                                    'transparent',
                                                            color: item.status ? 'white' : 'inherit',
                                                        }}
                                                    >
                                                        {item.status || ''}
                                                    </span>
                                                </td>
                                                <td className={styles.table__item_student}>
                                                    <div className={styles.table__item__div}>
                                                        <button onClick={() => handleOpenWindow(item)} className={styles.editBtn}>📂 </button>
                                                    </div>
                                                </td>

                                            </tr>
                                        ))}

                                        {/* Итого */}

                                    </tbody>
                                    <div className={styles.pagination}>
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                            <button
                                                key={page}
                                                onClick={() => setCurrentPage(page)}
                                                style={{
                                                    padding: '5px 10px',
                                                    background: currentPage === page ? '#736CED' : '#f0f0f0',
                                                    color: currentPage === page ? '#fff' : '#000',
                                                    border: '1px solid #ccc',
                                                    borderRadius: "6px",
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                    </div>



                                </table>
                            </>
                        )}
                        {activeForm === "release" && (
                            <StudentsRelease
                                render={render}
                                setRender={setRender}
                                id={id}></StudentsRelease>
                        )}
                        {activeForm === "courseforcourse" && (
                            <StudentsCourseForCourse
                                render={render}
                                setRender={setRender}
                                id={id}></StudentsCourseForCourse>
                        )}
                    </>


                </>
            )}

            {openWindowId && (
                <StudentDetailContent
                    foun_id={id}
                    id={openWindowId}
                    render={render}
                    setRender={setRender}
                    nameStudent={openWindowName}
                    onBack={handleCloseWindow}
                />
            )}
            <ModalWindow
                openModal={openModal}
                setOpenModal={setOpenModal}
                modalText={'Новый студент'}
            >
                <>
                    <div className={styles["note-input"]}>

                        <form onSubmit={handleSubmit} >
                            <div className={styles.form_input}>
                                <div>
                                    <label>ИНН:</label>
                                    <input
                                        type="number"
                                        placeholder="Введите ИНН:"
                                        value={inn}
                                        name="name"
                                        onChange={(e) => setInn(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={styles.div_check}>
                                <div>
                                    <label>Учебный год:</label>
                                    <select
                                        value={academicYearID}
                                        onChange={(e) => handleSelectAcademicYear(e.target.value)}
                                    >
                                        <option value="">Выберите учебный год</option>
                                        {Array.isArray(academicyears) && academicyears.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label>Вид обучения:</label>
                                    <select
                                        value={educationTypeID}
                                        onChange={(e) => handleSelectEducationType(e.target.value)}
                                    >
                                        <option value="">Выберите вид обучения</option>
                                        {Array.isArray(educationtypes) && educationtypes.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className={styles.div_check}>

                                <div>
                                    <label>Филиал:</label>
                                    <select
                                        value={branchID}
                                        onChange={(e) => handleSelectBranch(e.target.value)}
                                    >
                                        <option value="">Выберите филиал</option>
                                        {Array.isArray(branches) && branches.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label>Подразделение:</label>
                                    <select
                                        value={departmentID}
                                        onChange={(e) => handleSelectDepartment(e.target.value)}
                                    >
                                        <option value="">Выберите подразделение</option>
                                        {Array.isArray(departments) && departments.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label>Специальность:</label>
                                    <select
                                        value={specialitieID}
                                        onChange={(e) => handleSelectSpecialitie(e.target.value)}
                                    >
                                        <option value="">Выберите специальность</option>
                                        {Array.isArray(specialities) && specialities.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label>Курс:</label>
                                    <select
                                        value={courseID}
                                        onChange={(e) => handleSelectCourse(e.target.value)}
                                    >
                                        <option value="">Выберите курс</option>
                                        {Array.isArray(courses) && courses.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className={styles.form_input}>
                                <div>
                                    <label>Фамилия:</label>
                                    <input
                                        type="text"
                                        placeholder="Введите Фамилию:"

                                        value={surname}
                                        name="name"
                                        onChange={(e) => setSurname(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>Имя:</label>
                                    <input
                                        type="text"
                                        placeholder="Введите Имя:"

                                        value={first_name}
                                        name="name"
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>Отчество:</label>
                                    <input
                                        type="text"
                                        placeholder="Введите Отчество:"

                                        value={last_name}
                                        name="name"
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label>Гражданство:</label>
                                    <input
                                        type="text"
                                        placeholder="Введите гражданство:"

                                        value={citizenship}
                                        name="name"
                                        onChange={(e) => setCitizenship(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>Приказ о зачислении:</label>
                                    <input
                                        type="text"
                                        placeholder="Введите приказ:"

                                        value={order}
                                        name="name"
                                        onChange={(e) => setOrder(e.target.value)}
                                    />
                                </div>
                            </div>


                            <div className={styles.create_footer}>


                                <button
                                    type="submit"
                                    className={styles.open_btn_sub}

                                >
                                    Создать
                                </button>
                            </div>
                        </form>
                    </div>
                    <Button
                        onClick={() => setOpenModal(false)}
                        className={styles.close_btn_sub}
                    >
                        {" "}
                        Закрыть
                    </Button>
                </>
            </ModalWindow >
            <Notification notify={notify} setNotify={setNotify} />



        </>


    );
};

export default StudentsContent;
